export default function CounterSection() {
	return (
		<div className="fugu--counter-section">
			<div id="fugu--counter"></div>
			<div className="container">
				<div className="fugu--counter-wrap fugu--counter-wrap3">
					<div className="fugu--counter-data wow fadeInUpX" data-wow-delay=".10s">
						<h2>
							<span data-percentage="45" className="fugu--counter">
								0
							</span>
							<strong>K</strong>
						</h2>
						<p>Digital Artworks</p>
					</div>
					<div className="fugu--counter-data wow fadeInUpX" data-wow-delay=".20s">
						<h2>
							<span data-percentage="87" className="fugu--counter">
								0
							</span>
							<strong>K</strong>
						</h2>
						<p>Registered investors</p>
					</div>
					<div className="fugu--counter-data wow fadeInUpX" data-wow-delay=".30s">
						<h2>
							<span data-percentage="60" className="fugu--counter">
								0
							</span>
							<strong>K</strong>
						</h2>
						<p>Total transactions</p>
					</div>
					<div className="fugu--counter-data wow fadeInUpX" data-wow-delay=".40s">
						<h2>
							<span data-percentage="32" className="fugu--counter">
								0
							</span>
							<strong>K</strong>
						</h2>
						<p>Global Creators</p>
					</div>
				</div>
			</div>
		</div>
	);
}
